


export const TabMenus = ["System Status", "Room Occupancy", "Energy Usage"]

export const chartPhoneStyle = (theme : any) => { 
    return {
        marginTop: 3,
        [theme.breakpoints.only('pp')]: {
            marginLeft: -10,
        }
    }
}
export const chartInnerFont = (theme : any) => { 
    return {
        [theme.breakpoints.only('pp')]: {
            fontSize: 9,
        }
    }
}
